import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element }) => {
    const isAuthenticated = () => {
        const user = localStorage.getItem('user_id');
        return user !== null;
    };
    const sessionStillValid = () => {
        fetch('/api/auth', {
            method: 'GET',
        }).then((response) => {
            if (response.status !== 200) {
                localStorage.removeItem('user_id');
                window.location.href = '/admin/login';
            }
        });
    }
    
    if (!isAuthenticated()) {
        return <Navigate to="/admin/login" />;
    }

    sessionStillValid();

    return element;
};

export default PrivateRoute;
